import React from 'react';
import { UniversalContentImporter } from './UniversalContentImporter';
import { useBulkImageImport } from '@/hooks/content-generator/useBulkImageImport';

interface ProjectImportImagesEmptyStateProps {
  projectId: string;
  onImportComplete?: () => void;
}

export const ProjectImportImagesEmptyState: React.FC<ProjectImportImagesEmptyStateProps> = ({
  projectId,
  onImportComplete
}) => {
  const bulkImportMutation = useBulkImageImport(projectId);

  const handleBulkImport = async (selectedIds: string[]) => {
    try {
      await bulkImportMutation.mutateAsync(selectedIds);
      onImportComplete?.();
    } catch (error) {
      console.error('Failed to import images:', error);
      throw error;
    }
  };

  return (
    <div className="h-[600px]">
      <UniversalContentImporter
        contentType="images"
        projectId={projectId}
        onBulkImport={handleBulkImport}
        layout="grid"
        showBulkActions={true}
        showClearButton={false}
        showSearch={true}
        className="h-full"
      />
    </div>
  );
}; 